module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/arrow-55007a586bea25b68ee35c3e91b54040.svg";